import React, { useState, useEffect, forwardRef } from 'react';
import ReceiptLogo from 'Components/Logo/ReceiptLogo';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    DialogContentText,
    DialogTitle,
    Slide,
    Box
} from '@material-ui/core';
import { CLIENT_NAME } from 'Config';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { Grid } from '@material-ui/core';

import TableCell from '@material-ui/core/TableCell';

import Success from 'Assets/Images/success.png';
import Fail from 'Assets/Images/fail.png';

import TableRow from '@material-ui/core/TableRow';
import CommonPrint from 'Components/Print/CommonPrint';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';

const StyledTableCell = withStyles((theme) => ({
    body: {
        fontSize: 16,
        fontWeight: 'bold'
    }
}))(TableCell);

const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export function DMTTransactionPrint({
    isOpen,
    title,
    request,
    positiveButtonTitle,
    positiveButtonClick,
    negativeButtonTitle,
    negativeButtonClick
}) {
    const [open, setOpen] = useState(isOpen);
    const classes = commonStyle();

    const handleNegativeButtonClick = () => {
        setOpen(false);
        negativeButtonClick();
    };
    const handlePositiveA4ButtonClick = () => {
        let pageSize = 'A4';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };
    const handlePositiveA5ButtonClick = () => {
        let pageSize = 'A5';
        CommonPrint(pageSize);
        positiveButtonClick(request);
    };

    return (
        <Dialog
            classes={{ paperFullScreen: 'prePrint' }}
            //fullScreen
            open={open}
            onClose={() => {
                setOpen(false);
                negativeButtonClick(false);
            }}
            TransitionComponent={Transition}
        >
            <DialogTitle id="alert-dialog-title" className={classes.title}>
                {title}
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="DialogPrint">
                    <PrintDetails request={request} />
                </DialogContentText>
            </DialogContent>
            <DialogActions displayPrint="none">
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <Button
                            onClick={handleNegativeButtonClick}
                            className={classes.CustomSecondaryButtonStylePopup}
                        >
                            {negativeButtonTitle
                                ? negativeButtonTitle
                                : 'No, Cancel Print'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveA4ButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle ? positiveButtonTitle : 'A4'}
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={3} lg={3}>
                        <Button
                            onClick={handlePositiveA5ButtonClick}
                            className={classes.CustomPrimaryButtonStylePopup}
                        >
                            {positiveButtonTitle ? positiveButtonTitle : 'A5'}
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    );
}

const PrintDetails = (request) => {
    let data = request.request;

    const [rows, setRows] = useState([]);
    const [logo, setLogo] = useState([]);
    const [IsShowCharge, setIsShowCharge] = useState(true);
    const [cName, setCName] = useState('');
    async function fetchCName() {
        setCName(await CLIENT_NAME());
    }
    let transaction = data.List;

    const ShowServiceCharge = () => {
        if (data.Charge === '0') {
            setIsShowCharge(false);
            return;
        }
    };

    useEffect(() => {
        ShowServiceCharge();
        createRowForLogo();
        createRow();
        fetchCName();
    }, []);

    const createRowForLogo = () => {
        let dummyRows = [];
        dummyRows.push(LogoData(<ReceiptLogo />, 'Date:', transaction[0].DOC));
        setLogo(dummyRows);
    };

    function LogoData(Parameter1, Parameter2, Values2) {
        return { Parameter1, Parameter2, Values2 };
    }

    const GetImageByStatus = (status) => {
        if (status === 'SUCCESS') {
            return <img src={Success} height={20} width={20} alt="success" />;
        } else if (status === 'FAILURE') {
            return <img src={Fail} height={20} width={20} alt="fail" />;
        }
    };

    const createRow = () => {
        let dummyRows = [];

        dummyRows.push(DMTData('Name: ', data.BeneName));
        dummyRows.push(DMTData('Bank: ', data.Bank));
        dummyRows.push(DMTData('A/c No.: ', data.ConsumerNumber));
        dummyRows.push(DMTData('IFSC: ', data.IFSC));
        dummyRows.push(DMTData('Total Amount: ', data.TotalAmount));
        dummyRows.push(DMTData('Charge: ', data.Charge));

        setRows(dummyRows);
    };

    function DMTData(Parameter1, Values1) {
        return { Parameter1, Values1 };
    }

    return (
        <Grid item xs={12}>
            <Box
                style={{
                    border: '2px solid #000',
                    padding: '5px',
                    marginTop: '10px',
                    marginLeft: '10px',
                    backgroundColor: '#fff',
                    //width: '340px',
                    //height: '100%',
                    position: 'relative'
                }}
            >
                <p style={{ textAlign: 'center', marginBottom: '10px' }}>
                    <ReceiptLogo />
                </p>

                <Box
                    style={{
                        marginTop: '8px',
                        color: '#000',
                        borderBottom: '1px solid #000',
                        fontSize: '14px'
                    }}
                >
                    <span style={{ fontWeight: 'bold' }}>{data.FirmName}</span>
                </Box>

                <Box
                    style={{
                        color: '#000',
                        margin: '5px 0',
                        borderBottom: '1px solid #ccc',
                        paddingBottom: '2px',
                        fontSize: '14px'
                    }}
                >
                    Sender : {data.SenderNo} ({data.PersonName})
                </Box>
                {rows.map((row) => (
                    <Box
                        style={{
                            paddingBottom: '5px'
                        }}
                    >
                        <p
                            style={{
                                margin: '0px',
                                color: '#000',
                                fontSize: '12px'
                            }}
                        >
                            {row.Parameter1}
                            <span style={{ fontWeight: 'bold' }}>
                                {row.Values1}
                            </span>
                        </p>
                    </Box>
                ))}
                <Box
                    style={{
                        borderTop: '1px solid #000',
                        display: 'flex'
                    }}
                >
                    <h1
                        style={{
                            fontSize: '14px',
                            color: '#000',
                            marginTop: '5px',
                            marginBottom: '8px'
                        }}
                    >
                        <span style={{ borderBottom: '2px solid #000' }}>
                            Transaction Details on
                        </span>
                        <span
                            style={{
                                fontSize: '12px',
                                marginLeft: '10px',
                                fontWeight: 'normal',
                                alignItems: 'end'
                            }}
                        >
                            {transaction[0].DOC}
                        </span>
                    </h1>
                </Box>
                {transaction.map((trans, index) => (
                    <Box>
                        <TableContainer>
                            <Table aria-label="customized table">
                                <TableBody>
                                    <TableRow>
                                        <StyledTableCell
                                            align="left"
                                            style={{
                                                paddingTop: '1px',
                                                paddingRight: '0px',
                                                paddingBottom: '0px',
                                                paddingLeft: '0px',
                                                width: '100%',
                                                margin: '0px'
                                            }}
                                        >
                                            <h6
                                                style={{
                                                    fontSize: '14px',
                                                    fontWeight: 'bold',
                                                    marginBottom: '0px',
                                                    color: '#000'
                                                }}
                                            >
                                                UTR :
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        color: '#000',
                                                        fontWeight: 'normal'
                                                    }}
                                                >
                                                    {trans.UTRNumber}
                                                </span>
                                            </h6>
                                            <p
                                                style={{
                                                    fontSize: '12px',
                                                    marginBottom: '0px',
                                                    color: '#000'
                                                }}
                                            >
                                                Rs. :
                                                <span
                                                    style={{
                                                        fontSize: '14px',
                                                        fontWeight: 'bold',
                                                        color: '#000'
                                                    }}
                                                >
                                                    {trans.Amount}
                                                </span>
                                            </p>
                                        </StyledTableCell>
                                        <StyledTableCell
                                            align="left"
                                            style={{
                                                padding: '0px',
                                                width: '100%',
                                                textAlign: 'center',
                                                fontSize: '10px',
                                                color: '#000',
                                                margin: '0px'
                                            }}
                                        >
                                            {GetImageByStatus(trans.Status)}
                                            {trans.Status}
                                        </StyledTableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                ))}
                {IsShowCharge ? (
                    <Box>
                        <p
                            style={{
                                padding: '0px',
                                color: '#000',
                                marginTop: '2px',
                                fontSize: '10px'
                            }}
                        >
                            Service Charge :
                            <span
                                style={{ fontWeight: 'bold', fontSize: '12px' }}
                            >
                                Rs.{data.Charge}
                            </span>
                        </p>
                    </Box>
                ) : null}
                <Box>
                    <p
                        style={{
                            padding: '3px 5px',
                            margin: '0px',
                            backgroundColor: '#ccc',
                            color: '#000',
                            fontSize: '10px',
                            textAlign: 'center',
                            bottom: '5px',
                            width: '100%'
                        }}
                    >
                        This is system generated receipt. Hence no seal or
                        signature required
                        <br />
                        Thank you for using {cName}
                    </p>
                </Box>
            </Box>
        </Grid>
    );
};
